var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCamera = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10.07 4.85a1.15 1.15 0 0 0-.956.512L8.3 6.581A2.85 2.85 0 0 1 5.93 7.85H5A1.15 1.15 0 0 0 3.85 9v9c0 .635.515 1.15 1.15 1.15h14A1.15 1.15 0 0 0 20.15 18V9A1.15 1.15 0 0 0 19 7.85h-.93a2.85 2.85 0 0 1-2.37-1.27l-.813-1.218a1.15 1.15 0 0 0-.957-.512zM7.7 4.419a2.85 2.85 0 0 1 2.37-1.27h3.86a2.85 2.85 0 0 1 2.371 1.27l.813 1.219c.213.32.572.512.957.512H19A2.85 2.85 0 0 1 21.85 9v9A2.85 2.85 0 0 1 19 20.85H5A2.85 2.85 0 0 1 2.15 18V9A2.85 2.85 0 0 1 5 6.15h.929c.385 0 .744-.192.957-.512zm4.3 6.43a2.15 2.15 0 1 0 0 4.3 2.15 2.15 0 0 0 0-4.3M8.15 13a3.85 3.85 0 1 1 7.7 0 3.85 3.85 0 0 1-7.7 0",
  clipRule: "evenodd"
})));
export default SvgCamera;